import { Cittadinanza } from '@hm_app/@core/models/dettaglio_profilo';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class CittadinanzeService {

    // Observable sources
    private cittadinanza = new BehaviorSubject<Cittadinanza>(null);

    // Observable streams
    cittadinanzaObservable = this.cittadinanza.asObservable();

    // Service message commands
    passCittadinanza(cittadinanza: Cittadinanza) {
        this.cittadinanza.next(cittadinanza);
    }
}
